<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="24">
          <ReportByProductByMonthFilters
            @onYearSelected="OnYearSelected"
            @thecnicianChaged="OnThecnicianChaged"
            @customerServiceChanged="OnCustomerServiceChanged"
            @resquestTypeChanged="OnResquestTypeChanged"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <ReportByProductByMonthTable
            :yearSelected="yearSelected"
            :thecnicianSelected="thecnicianSelected"
            :customerServiceCode="customerServiceCode"
            :requestTypeSelected="requestTypeSelected"
            @OpeningDetailDialosg="OnDetailDialogOpen"
          />
        </el-col>
      </el-row>
      <MonthlyRequestsByProductsReportDetail
        :DialoVisible="detailDialogVisible"
        :YearSelected="yearSelected"
        :ThecnicianSelected="thecnicianSelected"
        :CustomerServiceCode="customerServiceCode"
        :Month="monthSelected"
        :ProductId="productId"
        :ProductName="productName"
        :RequestTypeSelected="requestTypeSelected"
        @ClosingDialog="OnDetailDialogClose"
      />
    </el-main>
  </el-container>
</template>

<script>
import ReportByProductByMonthFilters from "@/components/requests/reports/reportByproductByMonth/ReportByProductByMonthFilters";
import ReportByProductByMonthTable from "@/components/requests/reports/reportByproductByMonth/ReportByProductByMonthTable";
import MonthlyRequestsByProductsReportDetail from "@/components/requests/reports/reportByproductByMonth/detail/MonthlyRequestsByProductsReportDetail";

const actualYear = new Date().getFullYear();

export default {
  name: "RequestByProduct",
  components: {
    ReportByProductByMonthFilters,
    ReportByProductByMonthTable,
    MonthlyRequestsByProductsReportDetail
  },
  data() {
    return {
      yearSelected: actualYear,
      monthSelected: null,
      thecnicianSelected: 0,
      customerServiceCode: 0,
      requestTypeSelected: 0,
      productId: null,
      productName: "",
      detailDialogVisible: false
    };
  },
  methods: {
    OnYearSelected(year) {
      this.yearSelected = year;
    },
    OnThecnicianChaged(thecnicianId) {
      this.thecnicianSelected = thecnicianId;
    },
    OnCustomerServiceChanged(val) {
      this.customerServiceCode = val;
    },
    OnResquestTypeChanged(val) {
      this.requestTypeSelected = val;
    },
    OnDetailDialogClose(val) {
      this.detailDialogVisible = val;
    },
    OnDetailDialogOpen(val, month, productId, productDescription) {
      this.monthSelected = month;
      this.productId = productId;
      this.productName = productDescription;
      this.detailDialogVisible = val;
    }
  }
};
</script>

<style lang="scss" scoped></style>
